import { render, staticRenderFns } from "./ingredient.vue?vue&type=template&id=23a07309&"
import script from "./ingredient.vue?vue&type=script&lang=js&"
export * from "./ingredient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23a07309')) {
      api.createRecord('23a07309', component.options)
    } else {
      api.reload('23a07309', component.options)
    }
    module.hot.accept("./ingredient.vue?vue&type=template&id=23a07309&", function () {
      api.rerender('23a07309', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/data-dictionary/cartridge-ingredient/ingredient.vue"
export default component.exports